export default __webpack_public_path__ + "static/media/true-false-icon.101ab7ef.png";